"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationInfoButton = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const react_1 = tslib_1.__importStar(require("react"));
const react_popper_tooltip_1 = require("react-popper-tooltip");
const data_1 = require("@grafana/data");
const ui_1 = require("@grafana/ui");
const FlexItem_1 = require("../../QueryEditor/FlexItem");
exports.OperationInfoButton = react_1.default.memo(({ definition, operation, innerQueryPlaceholder }) => {
    const styles = (0, ui_1.useStyles2)(getStyles);
    const [show, setShow] = (0, react_1.useState)(false);
    const { getTooltipProps, setTooltipRef, setTriggerRef, visible } = (0, react_popper_tooltip_1.usePopperTooltip)({
        placement: 'top',
        visible: show,
        offset: [0, 16],
        onVisibleChange: setShow,
        interactive: true,
        trigger: ['click'],
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ui_1.Button, { title: "Click to show description", ref: setTriggerRef, icon: "info-circle", size: "sm", variant: "secondary", fill: "text" }),
        visible && (react_1.default.createElement(ui_1.Portal, null,
            react_1.default.createElement("div", Object.assign({ ref: setTooltipRef }, getTooltipProps(), { className: styles.docBox }),
                react_1.default.createElement("div", { className: styles.docBoxHeader },
                    react_1.default.createElement("span", null, definition.renderer(operation, definition, innerQueryPlaceholder)),
                    react_1.default.createElement(FlexItem_1.FlexItem, { grow: 1 }),
                    react_1.default.createElement(ui_1.Button, { icon: "times", onClick: () => setShow(false), fill: "text", variant: "secondary", title: "Remove operation" })),
                react_1.default.createElement("div", { className: styles.docBoxBody, dangerouslySetInnerHTML: { __html: getOperationDocs(definition, operation) } }))))));
});
exports.OperationInfoButton.displayName = 'OperationDocs';
const getStyles = (theme) => {
    return {
        docBox: (0, css_1.css)({
            overflow: 'hidden',
            background: theme.colors.background.primary,
            border: `1px solid ${theme.colors.border.strong}`,
            boxShadow: theme.shadows.z3,
            maxWidth: '600px',
            padding: theme.spacing(1),
            borderRadius: theme.shape.radius.default,
            zIndex: theme.zIndex.tooltip,
        }),
        docBoxHeader: (0, css_1.css)({
            fontSize: theme.typography.h5.fontSize,
            fontFamily: theme.typography.fontFamilyMonospace,
            paddingBottom: theme.spacing(1),
            display: 'flex',
            alignItems: 'center',
        }),
        docBoxBody: (0, css_1.css)({
            // The markdown paragraph has a marginBottom this removes it
            marginBottom: theme.spacing(-1),
            color: theme.colors.text.secondary,
        }),
        signature: (0, css_1.css)({
            fontSize: theme.typography.bodySmall.fontSize,
            fontFamily: theme.typography.fontFamilyMonospace,
        }),
        dropdown: (0, css_1.css)({
            opacity: 0,
            color: theme.colors.text.secondary,
        }),
    };
};
function getOperationDocs(def, op) {
    var _a;
    return (0, data_1.renderMarkdown)(def.explainHandler ? def.explainHandler(op, def) : (_a = def.documentation) !== null && _a !== void 0 ? _a : 'no docs');
}
//# sourceMappingURL=OperationInfoButton.js.map